import React from "react";

import { useMyCashPoolingRole } from "../cash-pooling-roles/hooks/useCashPoolingRoles";
import { Spinner } from '@datanomik/core-ui';
import { CashPoolingUnauthorizedPage } from "./CashPoolingUnauthorizedPage";

/**
 * Gates every cash-pooling view: shows a spinner while the /me role probe resolves, then the unauthorized page
 * when the user has no role. The /me query is cached, so wrapping each route adds no extra requests.
 */
export const CashPoolingAccessGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data: role, isLoading } = useMyCashPoolingRole();

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-100">
        <Spinner tone="primary" />
      </div>
    );
  }

  if (!role) {
    return <CashPoolingUnauthorizedPage />;
  }

  return <>{children}</>;
};
